module.exports = __webpack_public_path__ + "static/media/autobook.709285d0.svg";